import React from "react";
import * as PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import Tooltip from "@material-ui/core/Tooltip";
import styleConstants from "../../styleConstants";

const useStyles = makeStyles({
  number: {
    fontWeight: styleConstants.fontWeights.bold,
    color: styleConstants.colors.themeBlue,
    "&:hover": {
      cursor: "default"
    }
  },
  tooltip: {
    maxWidth: props => props.maxWidth,
    boxShadow: `0 0 0.75rem 0 rgba(184, 184, 184, 0.5)`,
    backgroundColor: "white",
    borderRadius: 0,
    fontSize: "0.75rem",
    fontWeight: styleConstants.fontWeights.book,
    color: styleConstants.colors.gray6
  }
});

const Reference = props => {
  const classes = useStyles(props);

  return (
    <>
      <Tooltip
        title={props.children}
        interactive
        className="reference"
        classes={{
          tooltip: classes.tooltip
        }}>
        <span
          dangerouslySetInnerHTML={{
            __html: `[${props.marker}]`
          }}
          className={classes.number}
        />
      </Tooltip>
      {props.trailingSpace ? " " : ""}
    </>
  );
};

Reference.propTypes = {
  marker: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  maxWidth: PropTypes.number,
  leadingSpace: PropTypes.bool,
  trailingSpace: PropTypes.bool,
  children: PropTypes.node.isRequired
};

Reference.defaultProps = {
  leadingSpace: false,
  trailingSpace: true
};

export default Reference;
